import { render } from "./Linux.vue?vue&type=template&id=1c8de185&scoped=true"
import script from "./Linux.vue?vue&type=script&lang=js"
export * from "./Linux.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1c8de185"

export default script